<template>
    <div class='wux-nav'>
        <div class='wux-nav-left' @click='goBack' v-if="back">
            <div class="hand"><span class="icon icon-109"></span>{{$t('back')}}</div>
        </div>
        <div class='wux-nav-title'><slot></slot></div>
        <div class='wux-nav-right'></div>
    </div>
</template>

<script>
    export default {
        name: "myNav",
        props:{
            back: {
                default: false,
                type: Boolean,
            },
            fixed: {
                default: true,
                type: Boolean,
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>
    .wux-nav{
        display: flex;
        height: 60px;
        line-height: 60px;
        background-color: #fff;
    }
    .wux-nav .wux-nav-title{
        flex: 1;
        font-weight: bold;
        color: darkblue;
        white-space:nowrap;
        overflow:hidden;
        font-size: 22px;
        text-overflow:ellipsis;
        letter-spacing:5px;
        /*text-align: center;*/
        padding: 0 20px;
    }
    .wux-nav .wux-nav-left,.wux-nav .wux-nav-right{
        width: 150px;
        padding: 0 20px;
        color: #000;
    }
    .wux-nav .wux-nav-left{
        text-align: left;
        font-size: 22px;
        transition: all 0.5s ease-out;
    }
    .wux-nav .wux-nav-left .icon{
        font-size: 22px;
    }
    .wux-nav .wux-nav-left:active{
        transform: translate(-10px);
    }
</style>


// WEBPACK FOOTER //
// src/components/myNav.vue